import { render, staticRenderFns } from "./list_statis_zzhc_fengxian_filter.vue?vue&type=template&id=1927925a&scoped=true&"
import script from "./list_statis_zzhc_fengxian_filter.vue?vue&type=script&lang=js&"
export * from "./list_statis_zzhc_fengxian_filter.vue?vue&type=script&lang=js&"
import style0 from "./list_statis_zzhc_fengxian_filter.vue?vue&type=style&index=0&id=1927925a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1927925a",
  null
  
)

export default component.exports